import { styled } from "@mui/material/styles";

import { Confidence } from "../Confidence/Confidence";
import { TestView } from "../Coursebook/TestView";
import { Quiz } from "../Quiz/Quiz";
import { SlideThumbnails } from "../SlideThumbnails/SlideThumbnails";
import { Survey } from "../Survey/Survey";
import { Video } from "../Video/Video";
import { useViewport, View } from "./useViewport";

const ViewportContainer = styled("div")(({ theme }) => ({
  background: theme.palette.mode === "dark" ? theme.palette.background.default : theme.custom.palette.light,
  height: "100% !important",
}));

export const Viewport = (): React.ReactElement => {
  const { view } = useViewport();

  const viewElements = {
    [View.Video]: <Video />,
    [View.Confidence]: <Confidence />,
    [View.Slides]: <SlideThumbnails />,
    [View.Quiz]: <Quiz />,
    [View.Survey]: <Survey />,
    [View.Test]: <TestView />,
  };

  return (
    <ViewportContainer role="main" aria-label="Main content">
      {viewElements[view]}
    </ViewportContainer>
  );
};
